// The five semantic states (#11426).
//
// Status colour means JUDGEMENT. There are exactly five meanings and a
// client's own vocabulary maps onto one of them — "Full DD", "Wound down" and
// "Never engaged" are labels, not colours. This is what stops a stage list
// from becoming a rainbow the reader has to memorise.

export type SemanticState = "none" | "eval" | "active" | "watch" | "closed";

export const SEMANTIC_STATES: readonly SemanticState[] = [
  "none",
  "eval",
  "active",
  "watch",
  "closed",
];

/** What each state means, so a mapping can be checked against the intent. */
export const SEMANTIC_STATE_MEANING: Record<SemanticState, string> = {
  none: "not engaged / draft / never run",
  eval: "in progress / running / thinking",
  active: "done / succeeded / invested",
  watch: "needs attention / partial / stale",
  closed: "finished and parked / archived / passed",
};

export function isSemanticState(value: unknown): value is SemanticState {
  return (
    typeof value === "string" &&
    (SEMANTIC_STATES as readonly string[]).includes(value)
  );
}
